
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import COVERAPP from "@/utils/COVERAPP";
@Options({
  data() {
    return {
      // 事件list 第一维度
      yearArr: [],
      // 事件缩放颗粒
      status: 1,
      //弹框数据
      historyTitle: "",
      historyContent: "",
      historyId: "",
      historyVisible: false,
      showPosterBox: false,
      posterImg: "",
      statusChange: false, //控制动画
      isApp: false,
      openVisible: true,
      access:true//开机图
    };
  },
  computed: {
    ...mapState(["userInfo", "shareData", "activityData"]),
  },
  mounted() {
    let self = this;
    let homeShareData = JSON.parse(JSON.stringify(this.shareData));
    homeShareData.link = window.location.href;
    this.isApp = COVERAPP.Attribute.isApp();
    this.$common.onshare(homeShareData);
    this.getDetail();
  },
  watch: {
    yearArr(val, oldVal) {
      //普通的watch监听
      let self = this;
      self.$nextTick(function () {
        self.addNum();
      });
    },
  },
  methods: {
    // 页面指南关闭
    closeOpen() {
      this.openVisible = false;
    },
    // 数据格式化
    getDetail() {
      let self = this;
      self
        .$requestTime(
          "https://actapi.thepage.cn/vote?aid=60a71b02494472004175b5c1&rows=1000",
          {},
          "get"
        )
        .then((data) => {
          if (data.total && data.total > 0) {
            let list = data.list;
            console.log("newArr1", list);
            // 数据处理
            let newList = self.dataSort(list);
            console.log("排序后", newList);
            // 排序后的数据按照年份分组
            let yearArr = self.yearFormat(newList, 1);
            self.yearArr = yearArr;
            self.getLength(this.yearArr);
            console.log("year1", yearArr);
            self.$common.pageLoaded();
            this.$common.track("load", "进入百年百篇时间轴页面"); //埋点
          }
        })
        .catch((res: any) => {});
    },
    dataSort(datalist: Array<any>) {
      let newArr = datalist.sort(function (a, b) {
        let key1 = +(+(a.info.year* 10000) + a.info.news_id + '.' + a.votes)
        let key2 = +(+(b.info.year* 10000) + b.info.news_id + '.' + b.votes)
        return key1 - key2; //升序排列，return b-a; —>升序排列
      });
      return newArr
    },
    yearFormat(yearArr: Array<any>, status: number) {
      let yearLength = yearArr.length;
      let yearList = {};
      for (let i = 2021; i > 1920; i -= status) {
        let smallYear = i - status;
        let key = i + "-" + smallYear;
        yearList[key] = [];

        for (let j = 0; j < yearLength; j++) {
          let year = parseInt(yearArr[j].info.year);
          if (year == i && i == 2021) {
            yearList[key].push(yearArr[j]);
          } else if ((year < i && year > smallYear) || year == smallYear) {
            yearList[key].push(yearArr[j]);
          } else if (year == smallYear && smallYear == 1920) {
            yearList[key].push(yearArr[j]);
          }
        }
      }
      return yearList;
    },
    addNum() {
      let arr = document.getElementsByClassName("year-content");
      let len = arr.length;
      for (let i = 0; i < len; i++) {
        i % 2 ? arr[i].classList.add("even") : arr[i].classList.add("odd");
      }
    },
    openHistory(name: string, id: string) {
      this.$common.track("click", `百年百篇时间轴"${name}"事件被点击，id:"${id}"`); //埋点
      this.historyTitle = name;
      this.historyId = id;
      let self = this;
      // 测试环境
      // let apiBaseUrl = "https://cover-api.fm-dev.thecover.cn";
      let apiBaseUrl = "https://api.thecover.cn";

      // 正式环境
      if (location.href.indexOf("h5.thepage.cn") > -1) {
        apiBaseUrl = "https://api.thecover.cn";
      }
      self
        .$http(
          apiBaseUrl + "/wap/getDetail",
          {
            news_id: id,
            diversion_id: "",
            expireTimestampSign: "",
          },
          "post"
        )
        .then((data: any) => {
          // console.log("新闻数据", data.content);
          let content = data.content;
          if(content){
             self.historyContent= self.deleteA( content);
          }
        });
      this.historyVisible = true;
    },
    gohistory(event){
      let target = event.target
      let id = target.getAttribute('data-id')
      if(target.className ==='wiki' && id){
        window.location.href = `https://m.thecover.cn/history.html?id=${id}`
      }
    },
    // 百科内容清除第三方链接
    deleteA: function (data) {
        let pattern = new RegExp('href=\"cyclopedia:\/\/id=[0-9A-Za-z]+\"', "g");
        let newData = data.replace(pattern, 'href="javascript:;"');
        return newData;
    },
    closeHistory() {
      this.historyTitle = "";
      this.historyContent = "";
      this.historyId = "";
      this.historyVisible = false;
    },
    // 年份展示
    getLength(obj: object) {
      let num = 0;
      for (var item in obj) {
        num++;
      }
      this.yearListLength = num;
    },
    capitalizeStart: function (value) {
      return value.substring(0, 4);
    },
    capitalizeEnd: function (value) {
      return value.substring(5);
    },
    // 显示或隐藏海报、右侧按钮点击放到到最大颗粒且滑动到最小年
    clickRight() {
      let self = this;
      //海报
      if (!this.showPosterBox) {
        self.drawPoster();
        self.$common.track("click", `点击时间轴分享海报`); //埋点
      } else {
        self.showPosterBox = false;
      }
    },
    /*以下为生成分享图*/
    drawPoster() {
      let canvas = document.createElement("canvas");
      canvas.width = 1005;
      canvas.height = 1608;
      let ctx: any = canvas.getContext("2d");
      var posterImgs: any = [];
      posterImgs.push(
        this.defPreImage(require("../assets/img/map-poster.png"))
      );
      posterImgs.push(this.defPreImage(require("../assets/img/qrcode.png")));
      var that = this;
      Promise.all(posterImgs).then((imgs: any) => {
        ctx.drawImage(
          imgs[0],
          0,
          0,
          imgs[0].width,
          imgs[0].height,
          0,
          0,
          imgs[0].width,
          imgs[0].height
        );
        ctx.drawImage(
          imgs[1],
          0,
          0,
          imgs[1].width,
          imgs[1].height,
          1005 - imgs[1].width - 40,
          1588 - imgs[1].height,
          imgs[1].width,
          imgs[1].height
        );

        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("我是百年百篇时间轴", 50, 980);
        ctx.fillText("第", 50, 1125);
        ctx.fillText("期待您的加入，共觅岁月峥嵘！", 50, 1250);

        //绘制字体
        ctx.font = 'bold 120px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        // 设置为粗体
        var beginTime = 1622476800;//正式环境2021-06-01 00:00:00
        var textNum =
          10000 +
          Math.round((Math.round(Date.now() / 1000) - beginTime) * 0.183);
        ctx.fillText(textNum, 150, 1110);

        var numberWidth = ctx.measureText(textNum).width;
        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("位探秘者", 180 + numberWidth, 1125);

        this.posterImg = canvas.toDataURL("image/jpeg");
        this.showPosterBox = true;
      });
    },
    //加载图片
    defPreImage(imgPath) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.crossOrigin = "Anonymous";
        img.src = imgPath;
      });
    },
    // 点击海报分享图片
    posterImgClick(e) {
      // console.log("点击图片");
      const _this = this;
      COVERAPP.Method.shareImage({
        image: e.target.src.split(";base64,")[1],
        title: _this.shareData.title,
        desc: _this.shareData.desc,
        imgUrl: _this.shareData.imgUrl,
        link: _this.shareData.link,
        callback(ret: any) {
          // const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
          // const origin = data.origin || ''
          // if (origin != 'None' && !_this.$common.isEmpty(origin)) {
          //     _this.$common.track('share', '分享图片到' + origin)
          // } else {
          //     _this.$common.track('share', '分享图片');
          // }
        },
      });
    },
    // 进入页面
    accessPage(){
       this.access = false;
    }
  },
})
export default class Home extends Vue {}
